import { render, staticRenderFns } from "./Publication.vue?vue&type=template&id=1c086074&scoped=true&"
import script from "./Publication.vue?vue&type=script&lang=ts&"
export * from "./Publication.vue?vue&type=script&lang=ts&"
import style0 from "./Publication.vue?vue&type=style&index=0&id=1c086074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c086074",
  null
  
)

export default component.exports